if (!customElements.get('cart-discount-bar')) {
  class CartDiscountBar extends HTMLElement {
    connectedCallback() {
      this.fillAmount = this.querySelector('[data-fill="amount"]');
      this.checkpoint = this.querySelector('[data-checkpoint="1"]');
      this.labelTier1 = this.querySelector('[data-label="1"]');
      this.labelTier2 = this.querySelector('[data-label="2"]');
      this.messageEl = this.querySelector('[data-message]');

      this.cartUpdateUnsubscriber = window.MinimogEvents?.subscribe(
        window.MinimogTheme.pubSubEvents.cartUpdate,
        (event) => this.update(event.cart)
      );

      fetch(`${window.MinimogSettings.routes.cart}.js`)
        .then((res) => res.json())
        .then((cart) => this.render(cart));
    }

    disconnectedCallback() {
      this.cartUpdateUnsubscriber?.();
    }

    update(cart) {
      if (!cart || cart.errors) return;

      if (typeof cart.item_count !== 'number') {
        fetch(`${window.MinimogSettings.routes.cart}.js`)
          .then((res) => res.json())
          .then((freshCart) => this.render(freshCart));
        return;
      }

      this.render(cart);
    }

    render(cart) {
      const tier1Qty = parseInt(this.dataset.tier1Qty, 10) || 0;
      const tier2Amount = parseInt(this.dataset.tier2Amount, 10) || 0;
      this.tier1Qty = tier1Qty;
      this.tier2Amount = tier2Amount;

      const pct1 = Math.min((cart.item_count / tier1Qty) * 100, 100);
      const pct2 = Math.min((cart.total_price / tier2Amount) * 100, 100);

      let checkpointPct = 50;
      if (cart.item_count > 0) {
        const avgItemPrice = cart.total_price / cart.item_count;
        checkpointPct = Math.min(((avgItemPrice * tier1Qty) / tier2Amount) * 100, 100);
      }

      this.fillAmount.style.setProperty('--fill', `${pct2}%`);
      this.checkpoint.style.left = `${checkpointPct}%`;
      this.labelTier1.style.left = `${checkpointPct}%`;
      this.checkpoint.classList.toggle('is-reached', pct1 >= 100);
      this.labelTier1.classList.toggle('is-reached', pct1 >= 100);
      this.labelTier2.classList.toggle('is-reached', pct2 >= 100);
      this.classList.toggle('is-all-unlocked', pct1 >= 100 && pct2 >= 100);

      this.messageEl.innerHTML = this.buildMessage(cart, pct1, pct2);
    }

    buildMessage(cart, pct1, pct2) {
      const strings = window.MinimogStrings;

      if (pct1 < 100) {
        const remaining = Math.max(this.tier1Qty - cart.item_count, 0);
        return strings.discountBarTier1PrefixHtml + remaining + strings.discountBarTier1SuffixHtml;
      }

      if (pct2 < 100) {
        const remaining = Math.max(this.tier2Amount - cart.total_price, 0);
        return (
          strings.discountBarTier2PrefixHtml +
          formatMoney(remaining, window.MinimogSettings.money_format) +
          strings.discountBarTier2SuffixHtml
        );
      }

      return strings.discountBarAllUnlocked;
    }
  }

  customElements.define('cart-discount-bar', CartDiscountBar);
}
